/**
 * First-order free delivery — a customer's first order ships free regardless
 * of subtotal, independent of the always-on FREE_DELIVERY_THRESHOLD rule
 * (freeDeliveryThreshold.jsx), and stacks with the first-order subtotal
 * discount (firstOrderDiscount.jsx).
 *
 * This is an optimistic preview for the checkout UI — the amount actually
 * charged is enforced server-side in mzito-pay (payment.controller.ts),
 * which re-derives eligibility from Firestore order history rather than
 * trusting the client's delivery_fee, so replaying a "first order" payload
 * on a later order can't zero the delivery fee again.
 *
 * Maps onto the Discount schema (mzito-pay/src/interfaces/discount.interface.ts)
 * as: { scope: "delivery_fee", type: "free", eligibility: { kind: "first_order", maxUsesPerUser: 1 } }
 */

/**
 * @param {number} deliveryFee - Delivery fee before any discount
 * @param {boolean} isFirstOrder
 * @returns {{ deliveryFee: number, isFreeDelivery: boolean }}
 */
export function applyFirstOrderFreeDelivery(deliveryFee, isFirstOrder) {
  if (!isFirstOrder) return { deliveryFee, isFreeDelivery: false };
  return { deliveryFee: 0, isFreeDelivery: true };
}
